// @file composer_modal_alert pinia store
import { ALERT_SIGN_EMOJI } from '@@/bits/emoji'
import { defineStore } from 'pinia'
import { ref } from 'vue'

interface ComposerModalAlertData {
  title: string
  body: string
  iconSrc?: string | null
  primaryActionText?: string
  secondaryActionText?: string
  primaryActions?: Array<() => void>
  secondaryActions?: Array<() => void>
  isPrimaryActionDanger?: boolean
}

const defaultComposerModalAlertData: ComposerModalAlertData = {
  title: '',
  body: '',
  iconSrc: ALERT_SIGN_EMOJI.iconSrc,
  primaryActionText: '',
  secondaryActionText: '',
  primaryActions: [],
  secondaryActions: [],
  isPrimaryActionDanger: false,
}

const useComposerModalAlertStore = defineStore('composerModalAlert', () => {
  const isComposerAlertOpen = ref<boolean>(false)
  const composerModalAlertData = ref<ComposerModalAlertData>(defaultComposerModalAlertData)

  const openComposerAlert = (payload: ComposerModalAlertData): void => {
    isComposerAlertOpen.value = true
    composerModalAlertData.value = Object.assign({}, composerModalAlertData.value, payload)
  }

  const resetComposerAlert = (): void => {
    isComposerAlertOpen.value = false
    composerModalAlertData.value = Object.assign({}, composerModalAlertData.value, defaultComposerModalAlertData)
  }

  const executePrimaryActions = (): void => {
    ;(composerModalAlertData.value.primaryActions || []).forEach((action): void => {
      if (typeof action === 'function') {
        action()
      }
    })
    resetComposerAlert()
  }

  const executeSecondaryActions = (): void => {
    ;(composerModalAlertData.value.secondaryActions || []).forEach((action): void => {
      if (typeof action === 'function') {
        action()
      }
    })
    resetComposerAlert()
  }

  return {
    // State
    isComposerAlertOpen,
    composerModalAlertData,

    // Actions
    openComposerAlert,
    resetComposerAlert,
    executePrimaryActions,
    executeSecondaryActions,
  }
})
export { useComposerModalAlertStore }
